import { FC } from 'react';
import { appQueryParamsSelector } from '@doda/common/src/redux/features/queryParams';
import { useAppSelector } from 'redux/hooks';
import { Props } from '../../..';
import { OccupationArea } from '../../../OccupationArea';
import { IndustryArea } from '../../../IndustryArea';
import { LocationArea } from '../../../LocationArea';

export const PreBtn2: FC<Props> = ({
  conditions,
  modalAction,
  getJobCountAtModalDisplay,
  updateJobCount,
  onChangeIsShowOverlay,
}) => {
  const { occupation, location, routeStation, industry } = conditions;
  const {
    onOpenOccupationModal,
    onOpenLocationModal,
    onOpenRouteModal,
    onOpenIndustryModal,
  } = modalAction;
  const {
    getJobCountWithoutOccupation,
    getJobCountWithoutLocationAndStation,
    getJobCountWithoutIndustry,
  } = getJobCountAtModalDisplay;

  const { ind } = useAppSelector(appQueryParamsSelector);

  return (
    <>
      {ind && (
        <IndustryArea
          industry={industry}
          updateJobCount={updateJobCount}
          onClickOpenModal={() => {
            getJobCountWithoutIndustry();
            onOpenIndustryModal();
          }}
          onChangeIsShowOverlay={onChangeIsShowOverlay}
        />
      )}
      <OccupationArea
        occupation={occupation}
        updateJobCount={updateJobCount}
        onChangeIsShowOverlay={onChangeIsShowOverlay}
        onClickOpenModal={() => {
          getJobCountWithoutOccupation();
          onOpenOccupationModal();
        }}
      />
      <LocationArea
        location={location}
        routeStation={routeStation}
        updateJobCount={updateJobCount}
        onClickOpenLocationModal={() => {
          getJobCountWithoutLocationAndStation();
          onOpenLocationModal();
        }}
        onClickOpenStationModal={() => {
          getJobCountWithoutLocationAndStation();
          onOpenRouteModal();
        }}
        onChangeIsShowOverlay={onChangeIsShowOverlay}
      />
      {!ind && (
        <IndustryArea
          industry={industry}
          updateJobCount={updateJobCount}
          onClickOpenModal={() => {
            getJobCountWithoutIndustry();
            onOpenIndustryModal();
          }}
          onChangeIsShowOverlay={onChangeIsShowOverlay}
        />
      )}
    </>
  );
};
